import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NricService } from '@services/nric/nric.service';
import { SharedModule } from '@shared/shared.module';
import { Subject, takeUntil } from 'rxjs';
import { STEP2 } from 'src/app/interfaces/motor';
import { CLIENTTYPE, CONSTANTS, IDTYPE, REGEX } from 'src/app/shared/enums/index.enum';
import { SmeCertFormComponent } from '../../customer-partner/sme-cert-form/sme-cert-form.component';
import { SstFormDetailsComponent } from '../../customer-partner/sst-form-details/sst-form-details.component';
import { Select, Store } from '@ngxs/store';
import { SatMotorState } from '@store/sat-motor/sat-motor.state';
import { NX_MODAL_DATA, NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { CpSameAgentInfoComponent } from '../cp-same-agent-info/cp-same-agent-info.component';
import { BrnoService } from '@shared/services/brno/brno.service';
import { GET_POSTCODE_INFO, UPDATE_GEO_INDICATOR } from '@store/sat-motor/sat-motor.action';
import { BranchesMapComponent } from '@shared/components/branches-map/branches-map.component';
import { ScrollToError } from '@shared/classes/scroll-to-error';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { NxMomentDateModule } from "@aposin/ng-aquila/moment-date-adapter";
import { LayoutBreakPointsService } from '@shared/services/layout-break-points/layout-break-points.service';
import { emailValidator } from '@shared/classes/validators/email.validator';

@Component({
  selector: 'app-customer-partner-edit-modal',
  standalone: true,
  imports: [
    SharedModule,
    SmeCertFormComponent,
    SstFormDetailsComponent,
    BranchesMapComponent,
    NxMomentDateModule
  ],
  templateUrl: './customer-partner-edit-modal.component.html',
  styleUrl: './customer-partner-edit-modal.component.scss'
})
export class CustomerPartnerEditModalComponent implements OnInit {
  @ViewChild(BranchesMapComponent) child!: BranchesMapComponent;
  isShow : boolean;

  lov: any;
  cpDetails: any;
  dataSearch2: any;
  idType2List: any;
  cpSameAgentInfoModal?: NxModalRef<CpSameAgentInfoComponent>;
  mkagAgent: any;
  
  eInvoiceConsent: boolean = false;
  edocConsentInd: boolean = false;
  search_mode_address: boolean = true;
  customerEditForm: FormGroup;

  unsubscribe$ = new Subject<void>();
  motorPC: any;
  lovproductConfig: any;
  productAccessListData: any;
  lovPC: string;
  lovGeo: any;
  emailCheck : any;
  mobileView: boolean = false;
  idValue2Length: number;
  onlyNumber: boolean = false;
  contactNoRegex: RegExp = new RegExp(REGEX.CONTACT_NO);
  fixedLineNoRegex: RegExp = new RegExp(REGEX.FIXED_LINE_NO);

  atLeastMobileNoOrFixedLineNoStatus: boolean = true;
  isEndorsement: boolean = false;
  unitAddress1MaxErr: boolean = false;

  constructor(
    private nricService: NricService,
    private brnoService: BrnoService,
    private fb: FormBuilder,
    private store: Store,
    @Inject(NX_MODAL_DATA) data: any,
    private dialogRef: NxModalRef<any>,
    private readonly dialogService: NxDialogService,
    private layoutService: LayoutBreakPointsService,
  ) {
    this.lov = data.lov;
    this.cpDetails = data.cpDetails;
    this.eInvoiceConsent = data.eInvoiceConsent;
    this.edocConsentInd = data.edocConsentInd;
    this.mkagAgent = data.mkagAgent;
    this.isEndorsement = data?.isEndorsement;
  }

  ngOnInit() {
    this.layoutService.subscribeLayoutChanges().subscribe(() => {
      this.mobileView = !this.layoutService.renderDesktop();
    });

    if (this.isEndorsement) {
      this.motorPC = this.store.selectSnapshot<any>((state)=>state.SatMotorState?.endorsement?.step2?.endtUpdatedData?.productCode);
    } else {
      this.motorPC = this.store.selectSnapshot<any>((state) => state.SatMotorState.motor.step1?.issuance?.issuance?.productCode);
    }

    this.lovproductConfig = this.lov.productAccessConfigList;

    
    for (let i = 0; i < this.lovproductConfig.length; i++) {
    this.productAccessListData = this.lovproductConfig[i];
    this.lovPC = Object.keys( this.productAccessListData)[0]; 
  
      if (this.lovPC === this.motorPC) {
       this.lovGeo =this.productAccessListData[this.lovPC].geocodingEnableSat;
       this.emailCheck = this.productAccessListData[this.lovPC].emailCheckEnableSat;

        if(this.lovGeo == "true")
          {
            this.isShow = true;
          }
          else{
            this.isShow = false;
          }
      }
  }
    this.initIdType2List();
    this.customerEditForm = this.fb.group({
      name:[this.cpDetails.clientName ? this.cpDetails.clientName : '', Validators.required],
      nationality: [this.cpDetails.clientNationality ? this.cpDetails.clientNationality : ''],
      idType2:[this.cpDetails.idType2 ? this.cpDetails.idType2 : ''],
      idValue2:[this.cpDetails.idValue2 ? this.cpDetails.idValue2 : ''],
      tinNo:[this.cpDetails.clientTinNo ? this.cpDetails.clientTinNo : '', [Validators.pattern("^[a-zA-Z0-9]*$")]],
      gender:[this.cpDetails.clientGender ? this.cpDetails.clientGender : ''],
      maritalStatus:[this.cpDetails.clientMaritalStatus ? this.cpDetails.clientMaritalStatus : ''],
      dob:[{value: this.cpDetails.clientDateofBirth ? this.cpDetails.clientDateofBirth : '', disabled : true}],
      age:[{value:this.cpDetails.clientAge ? this.cpDetails.clientAge : '', disabled : true}],
      mobileNoCode:[this.cpDetails.clientMobileCode1 ? this.cpDetails.clientMobileCode1 :''],
      mobileNo:[this.cpDetails.clientMobileNo1 ? this.cpDetails.clientMobileNo1 : ''],
      fixedLineNoCode:[this.cpDetails.clientPartnerAddress.clientPhoneCode ? this.cpDetails.clientPartnerAddress.clientPhoneCode : ''],
      fixedLineNo:[this.cpDetails.clientPartnerAddress.clientPhoneNo ? this.cpDetails.clientPartnerAddress.clientPhoneNo : ''],
      faxNoCode:[this.cpDetails?.clientPartnerAddress?.clientFax1Code ? this.cpDetails.clientPartnerAddress.clientFax1Code : ''],
      faxNo:[this.cpDetails?.clientPartnerAddress?.clientFax1No ? this.cpDetails.clientPartnerAddress.clientFax1No : ''],
      email:[this.cpDetails.clientEmail ? this.cpDetails.clientEmail : '', emailValidator],
      showMapSwitcher:[false],
      unitNo:[this.cpDetails.clientPartnerAddress.clientUnitNo ? this.cpDetails.clientPartnerAddress.clientUnitNo : ''],
      address1:[this.cpDetails.clientPartnerAddress.clientAddress1Tmp ? this.cpDetails.clientPartnerAddress.clientAddress1Tmp : ''],//, Validators.required],
      address2:[this.cpDetails.clientPartnerAddress.clientAddress2 ? this.cpDetails.clientPartnerAddress.clientAddress2 : ''],
      address3:[this.cpDetails.clientPartnerAddress.clientAddress3 ? this.cpDetails.clientPartnerAddress.clientAddress3 : ''],
      postCode:[this.cpDetails.clientPartnerAddress.clientPostcode ? this.cpDetails.clientPartnerAddress.clientPostcode : '', Validators.required],
      city:[{value: this.cpDetails.clientPartnerAddress.clientCity ? this.cpDetails.clientPartnerAddress.clientCity : '', disabled: true}], // need to change disabled = false after connect to BE to get the postcode details
      state:[{value: this.cpDetails.clientPartnerAddress.clientState ? this.cpDetails.clientPartnerAddress.clientState : '', disabled: true}], // need to change disabled = false after connect to BE to get the postcode details
      country:[{value: this.getDefaultCountry(), disabled: true}], // need to change disabled = false after connect to BE to get the postcode details
      addressType:[this.cpDetails.clientPartnerAddress.clientAddressType ? this.cpDetails.clientPartnerAddress.clientAddressType : this.getDefaultAddressType()],
      clientGeoLatitude: [this.cpDetails.clientPartnerAddress.clientGeoLatitude ? this.cpDetails.clientPartnerAddress.clientGeoLatitude : ''],
      clientGeoLongitude: [this.cpDetails.clientPartnerAddress.clientGeoLongitude ? this.cpDetails.clientPartnerAddress.clientGeoLongitude : ''],
      clientGeoPlaceId: [this.cpDetails.clientPartnerAddress.clientGeoPlaceId ? this.cpDetails.clientPartnerAddress.clientGeoPlaceId : ''],
      clientGeoPlusCode: [this.cpDetails.clientPartnerAddress.clientGeoPlusCode ? this.cpDetails.clientPartnerAddress.clientGeoPlusCode : ''],
      clientGeoFormattedAddress: [this.cpDetails.clientPartnerAddress.clientGeoFormattedAddress ? this.cpDetails.clientPartnerAddress.clientGeoFormattedAddress : ''],
      emarketingConsentInd: [this.cpDetails.emarketingConsentInd]
    });

    this.initValidators();

    this.correctMobileFixedFaxCode();

    this.onChangeIdType2();
    this.onChangeDOB();
    this.onChangeMobileNo(true);
    this.onChangefixedLineNo();
    this.initAddressValidators();

    if(this.showIdType2AndIdValue2()) {
      this.setIdValue2Length();
        this.checkIdValue2IsOnlyNumber();
    }
  }

  getDefaultCountry(): string {
    const cpAddress = this.cpDetails?.clientPartnerAddress;

    if (!cpAddress) {
        return '';
    }

    return cpAddress.clientPostcode ? "MAL" : cpAddress.clientCountry ?? '';
  }

  initIdType2List() {
    if(this.cpDetails.clientType === CLIENTTYPE.INDIVIDUAL) {
      if(this.cpDetails.idType1 === IDTYPE.OLD_IC) {
         this.idType2List = [
          { code: IDTYPE.NRIC, descp: IDTYPE.NRIC_DESCP },
          { code: IDTYPE.POL, descp: IDTYPE.POL_DESCP }
        ]
      }
    }else {
      if(this.cpDetails.idType1 === IDTYPE.BR_NO) {
        this.idType2List = [
         { code: IDTYPE.NEW_BR_NO, descp: IDTYPE.NEW_BR_NO_DESCP }
       ]
     }else {
      this.idType2List = [
        { code: IDTYPE.BR_NO, descp: IDTYPE.BR_NO_DESCP }
      ]
     }
    }
  }

  initValidators() {
    this.initEmailValidators();

    if(this.isCompany) {
      this.initCompanyValidators();
    }else {
      this.initIndividualValidators();
    }
  }

  initEmailValidators() {
    if((this.emailCheck =="true")||(this.eInvoiceConsent)) {
      this.customerEditForm.controls['email'].setValidators([Validators.required, emailValidator]);
    }
  }

  initCompanyValidators() {
    // this.customerEditForm.controls['fixedLineNo'].addValidators([Validators.required]);
    if (this.eInvoiceConsent) {
      this.customerEditForm.controls['tinNo'].addValidators(Validators.required);
    }
  }

  initIndividualValidators() {
    this.customerEditForm.controls['maritalStatus'].setValidators(Validators.required);
    this.customerEditForm.controls['gender'].addValidators([Validators.required]);
    if(this.cpDetails.idType1 === IDTYPE.PASS) {
      this.customerEditForm.controls['nationality'].setValidators(Validators.required);
    }

    if(this.cpDetails.idType1 !== IDTYPE.NRIC) {
      this.customerEditForm.controls['dob'].setValidators(Validators.required);
    }
    this.customerEditForm.controls['mobileNo'].addValidators([Validators.required]);
  }

  initAddressValidators(){
    let cp = this.customerEditForm.getRawValue();
    if ([cp.unitNo, cp.address2, cp.address3].find((element) => element && element.length > 0)) {
      this.customerEditForm.controls['address1'].setValidators(Validators.required);
      this.customerEditForm.controls['address1'].updateValueAndValidity();
    } else {
      this.clearvalidatoraddr();
    }
    this.customerEditForm.controls['postCode'].setValidators(Validators.required);
    this.customerEditForm.controls['postCode'].updateValueAndValidity();
  }

  clearvalidatoraddr(){
    this.customerEditForm.controls['address1'].clearValidators();
    this.customerEditForm.controls['address1'].updateValueAndValidity();
  }

  onSubmit() {
    console.warn("name: ", this.customerEditForm.controls['name'].value);
  }

  toText(value: string): string | null {
    return value ? value.toUpperCase() : null;
  }

  changeSearchMode(event: any) {
    // debugger;
    if (event.value == "address") {
      this.search_mode_address = true;
    } else {
      this.search_mode_address = false;
    }
  }

  onBlurIdValue2(idValue2) {
    console.log("idValue2: ", idValue2)
    let idValue2Control = this.customerEditForm.controls['idValue2'];
    let idType2Control = this.customerEditForm.controls['idType2'];
    let idValue2Val = idValue2Control.value;
    let idType2Val = idType2Control.value;

    if (idValue2Val) {
      idValue2Control.clearValidators();
      switch (idType2Val) {
        case IDTYPE.NRIC:
          if (idValue2Val.length === 12) {
            const isValidNric = this.nricService.isNRICValid(idValue2Val);
            if (!isValidNric) {
              idValue2Control.setErrors({ 'wrongNricFormat': true });
            }else {
              this.customerEditForm.get('dob').setValue(this.getDateOfBirth(idValue2Val));
              this.customerEditForm.get('gender').setValue(this.nricService.autoPopulateGenderBasedOnNRIC(idValue2Val));
            }
          }else {
            idValue2Control.setErrors({ 'wrongNricFormat': true });
          }
          break;
        
        case IDTYPE.NEW_BR_NO:
          if(idValue2Val.length < 12) {
            idValue2Control.setErrors({ 'wrongNewBrnoFormat': true });
          }else {
            try {
              const isValidNewBrNo = this.brnoService.isBRNOValid(idValue2Val);
              if (!isValidNewBrNo) {
                idValue2Control.setErrors({ 'wrongNewBrnoFormat': true });
              }
            }catch (err) {
              idValue2Control.setErrors({ 'wrongNewBrnoFormat': true });
            }
            
          }
          break;
      }
      idType2Control.setValidators([Validators.required]);
    }else {
      idType2Control.removeValidators([Validators.required]);
    }
    idType2Control.updateValueAndValidity();
  }

  onChangeIdType2() {
    this.customerEditForm.controls['idType2'].valueChanges
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(value => {
      let idValue2Control = this.customerEditForm.controls['idValue2'];
      let idValue2Val = idValue2Control.value;
      if(value && !idValue2Val) {
        idValue2Control.setErrors({'required': true});        
      }
    });
  }

  getErrorType(errors) {
    if (errors.wrongNricFormat) {
      return 'wrongNricFormat';
    }

    if(errors.wrongNewBrnoFormat) {
      return 'wrongNewBrnoFormat';
    }

    if (errors.invalidDOB) {
      return 'invalidDOB';
    }

    if (errors.required) {
      return 'required';
    }

    return false;
  }

  onChangeDOB() {
    this.customerEditForm.controls['dob'].valueChanges
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(value => {
      let dobDate = new Date(value);
      const currentDate = new Date();
      
      currentDate.setHours(0,0,0,0);

      let dobYear = dobDate.getFullYear();
      let currentYear = currentDate.getFullYear();

      if(dobYear >= currentYear) {
        this.customerEditForm.controls['dob'].setErrors({'invalidDOB': true});
      }else {
        let age = currentYear - dobYear;
        this.customerEditForm.controls['age'].setValue(age);
      }
    });
  }

  onChangeAge() {
    console.log("age: ", this.customerEditForm.controls['age'].errors);
  }

  onChangeMobileNo(fromInit) {
    let mobileNo = this.customerEditForm.controls['mobileNo'].value;
    let mobileNoCode = this.customerEditForm.controls['mobileNoCode'].value;
    if(mobileNo) {
      // if(this.isCompany) {
      //   this.customerEditForm.controls['fixedLineNo'].removeValidators([Validators.required]);
      // }
      this.customerEditForm.controls['mobileNoCode'].setValidators([Validators.required]);

      if(!this.contactNoRegex.test(mobileNo)) {
        this.customerEditForm.controls['mobileNo'].setErrors({ pattern: true });
        return;
      }

      if(!fromInit && mobileNo && mobileNoCode) {
        this.checkIsSameAgentMobile();
      }
    }else {
      // if(this.isCompany) {
      //   this.customerEditForm.controls['fixedLineNo'].addValidators([Validators.required]);
      // }
      this.customerEditForm.controls['mobileNoCode'].removeValidators([Validators.required]);
    }
    // this.customerEditForm.controls['fixedLineNo'].updateValueAndValidity();
    this.customerEditForm.controls['mobileNoCode'].updateValueAndValidity();
    
  }

  onChangeEmail() {
    let email = this.customerEditForm.controls['email'].value;
    if(email) {
      this.checkIsSameAgentEmail();
    }
    this.customerEditForm.controls['email'].updateValueAndValidity();
    
  }

  onChangefixedLineNo() {
    let fixedLineNo = this.customerEditForm.controls['fixedLineNo'].value;
    this.customerEditForm.controls['fixedLineNoCode'].clearValidators();
    if(fixedLineNo) {
      // if(this.isCompany) {
      //   this.customerEditForm.controls['mobileNo'].removeValidators([Validators.required]);
      // }
      this.customerEditForm.controls['fixedLineNoCode'].setValidators([Validators.required]);

      if(!this.fixedLineNoRegex.test(fixedLineNo)) {
        this.customerEditForm.controls['fixedLineNo'].setErrors({ pattern: true });
        return;
      }

    }else {
      // this.customerEditForm.controls['mobileNo'].addValidators([Validators.required]);
      this.customerEditForm.controls['fixedLineNoCode'].removeValidators([Validators.required]);
    }
    // this.customerEditForm.controls['mobileNo'].updateValueAndValidity();
    this.customerEditForm.controls['fixedLineNoCode'].updateValueAndValidity();
  }

  onChangeFaxNo() {
    let faxNo = this.customerEditForm.controls['faxNo'].value;
    this.customerEditForm.controls['faxNoCode'].clearValidators();
    this.customerEditForm.controls['faxNo'].clearValidators();
    if(faxNo) {
      // this.customerEditForm.controls['faxNo'].setValidators([Validators.pattern("^\\d{7,8}$")]);
      this.customerEditForm.controls['faxNoCode'].setValidators([Validators.required]);

      if(!this.contactNoRegex.test(faxNo)) {
        this.customerEditForm.controls['faxNo'].setErrors({ pattern: true });
        return;
      }

    }
    this.customerEditForm.controls['faxNoCode'].updateValueAndValidity();
    this.customerEditForm.controls['faxNo'].updateValueAndValidity();
    
  }

  saveEdit() {
  this.initAddressValidators(); 

  let validForm = this.validateForm();

    if(this.customerEditForm.valid && validForm) {
      const geoCodedInd = this.store.selectSnapshot<any>((state)=>state.SatMotorState.geoCodedInd);
      console.log("edit customer partner form: ", this.customerEditForm.getRawValue());
      this.dialogRef.close(this.customerEditForm.getRawValue());
      
    }else {
      let invalidControls = [];
      const controls = this.customerEditForm.controls;

      for(const name in controls) {
        if(controls[name].invalid) {
          invalidControls.push(name);
        }
      }
      console.warn("invalid edit form: ", invalidControls);
      this.customerEditForm.markAllAsTouched();
      ScrollToError.scrollToError('.ng-invalid[formControlName]');
    }
    
  }

  openCPSameAgentInfoModal(type) {
    let message = "";
    if(type === "MOBILE") {
      message = "The mobile number you have keyed in is an agent's mobile number. If you proceed with this number, it is deemed that you have obtained the customer's consent to use this number as the contact number for this policy. Please confirm if this is correct or otherwise key-in the mobile number provided by the customer.";
    }else {
      message = "The email you have keyed in is an agent's email. If you proceed with this email, it is deemed that you have obtained the customer's consent to use this email as the contact email for this policy. Please confirm if this is correct or otherwise key-in the email provided by the customer.";
    }

    this.cpSameAgentInfoModal = this.dialogService.open(CpSameAgentInfoComponent, {
      showCloseIcon: false,
      disableClose: true,
      data: {
        message: message
      },
      width: '400px'
    });

    this.cpSameAgentInfoModal.afterClosed().subscribe(result => {
      if(result != "OK") {
        switch(type) {
          case "MOBILE":
            this.customerEditForm.controls['mobileNo'].setValue('');
          break;
          case "EMAIL":
            this.customerEditForm.controls['email'].setValue('');
          break;
        }
      }
    });
  }

  showNationality() {
    return this.cpDetails.clientType === CLIENTTYPE.INDIVIDUAL && this.cpDetails.idType1 === IDTYPE.PASS;
  }

  cancelEdit() {
    this.dialogRef.close();
  }

  onChangePostcode() {
    let postcode = this.customerEditForm.controls['postCode'].value;

    this.store.dispatch(new GET_POSTCODE_INFO(postcode)).subscribe(state => {
      let postcodeInfo = state.SatMotorState.data.postCodeInfo;
      this.customerEditForm.patchValue({
        state: postcodeInfo.state,
        city: postcodeInfo.city,
        country: "MAL"
      });
    });
  }

  populateForm(data: any) {
    
    //reset first before populate
    this.customerEditForm.patchValue({
      unitNo: '',
      address1: '',
      address2: '',
      address3: '',
      postCode: '',
      city: '',
      state: '',
      country: '',
      clientGeoLatitude : '',
      clientGeoLongitude : '',
      clientGeoPlaceId : '',
      clientGeoPlusCode : '',
      clientGeoFormattedAddress : ''
    });

    this.customerEditForm.patchValue({
      unitNo: data.unitNumber,
      address1: data.clientAddress1,
      address2: data.clientAddress2,
      address3: data.clientAddress3,
      postCode: data.clientPostcode,
      clientGeoLatitude : data.clientGeoLatitude,
      clientGeoLongitude : data.clientGeoLongitude,
      clientGeoPlaceId : data.clientGeoPlaceId,
      clientGeoPlusCode : data.clientGeoPlusCode,
      clientGeoFormattedAddress : data.clientGeoFormattedAddress
    });

    if (data.clientPostcode) {
      this.onChangePostcode();
    } else {
      this.customerEditForm.patchValue({
        city: data.clientCityDesc,
        state: data.clientStateDesc,
        country: data.clientCountryDesc,
      });
    }
  }

  getDateOfBirth(value) {
    return this.nricService.getDateOfBirth(value);
  }

  checkIsSameAgentMobile() {
    let mobileNo = this.customerEditForm.controls['mobileNo'].value;
    let mobileNoCode = this.customerEditForm.controls['mobileNoCode'].value;

    if(!this.isCompany && mobileNoCode == this.mkagAgent.agentMobileCode1 && mobileNo == this.mkagAgent.agentMobileNo1) {
      this.openCPSameAgentInfoModal("MOBILE");
    }
  }

  checkIsSameAgentEmail() {
    let email = this.customerEditForm.controls['email'].value;
    if(!this.isCompany && email.toUpperCase() == this.mkagAgent.agentEmail.toUpperCase()) {
      this.openCPSameAgentInfoModal("EMAIL");
    }
  }

  onChangeMobileNoCode() {
    let mobileNo = this.customerEditForm.controls['mobileNo'].value;
    let mobileNoCode = this.customerEditForm.controls['mobileNoCode'].value;
    if(mobileNo && mobileNoCode) {
      this.checkIsSameAgentMobile();
    }
  }

    validateUnitAddress1MaxLength() {
    let address1Control = this.customerEditForm.get("address1");
    let unitNoControl = this.customerEditForm.get("unitNo");

    let address1length = address1Control.value ? address1Control.value.length : 0;
    let unitNolength = unitNoControl.value ? unitNoControl.value.length : 0;

    const unitAddress1Length = address1length + unitNolength + 2;

    if (unitAddress1Length > 100) {
      this.unitAddress1MaxErr = true;
      return true;
    }else {
      this.unitAddress1MaxErr = false;
      return false;
    }

  }


  get isCompany() {
    return this.cpDetails.clientType === CLIENTTYPE.COMPANY;
  }

  get isOldIC() {
    return this.cpDetails.idType1 === IDTYPE.OLD_IC;
  }

  get idValue2ErrorType() {
    let errors = this.customerEditForm.controls['idValue2'].errors;
    if (!errors) {
      return false;
    }
    return this.getErrorType(errors);
  }

  get dobErrorType() {
    let errors = this.customerEditForm.controls['dob'].errors;
    if (!errors) {
      return false;
    }
    return this.getErrorType(errors);
  }

  get isNric() {
    return this.cpDetails.idType1 === IDTYPE.NRIC;
  }

   //reset Address to null
   clearAddress(){
    this.store.dispatch(new UPDATE_GEO_INDICATOR(false));
    this.customerEditForm.controls['address1'].clearValidators();
    this.customerEditForm.controls['postCode'].clearValidators();
  
  this.customerEditForm.controls['address1'].updateValueAndValidity();
  this.customerEditForm.controls['postCode'].updateValueAndValidity();

  this.cpDetails ={
    ...this.cpDetails,
    clientAddress1:'',
    clientAddress1Tmp: '',
    clientAddress2:'',
    clientAddress3:'', 
    clientCity:'',
    clientCountry:'',
    clientGeoLatitude:'',
    clientGeoLongitude:'',
    clientGeoPlaceId:'',
    clientGeoPlusCode:'',
    clientPostcode:'',
    clientState:'',
    clientUnitNo:'',
  };

  this.customerEditForm.patchValue({
    unitNo: '',
    address1: '',
    address2: '',
    address3: '',
    postCode: '',
    city: '',
    state: '',
    country: '',
    showMapSwitcher: [true],
    clientGeoLatitude : '',
    clientGeoLongitude : '',
    clientGeoPlaceId : '',
    clientGeoPlusCode : '',
    clientGeoFormattedAddress : ''
  });
  this.child.clearAddress();
  this.store.dispatch(new UPDATE_GEO_INDICATOR(false));
}

getDefaultAddressType() {
  return this.isCompany ? 'O' : 'R';
}

idType2OnChange() {
  this.customerEditForm.controls['idValue2'].reset();

  this.setIdValue2Length();

  this.checkIdValue2IsOnlyNumber();
}

setIdValue2Length() {
  let value = this.customerEditForm.controls['idType2'].value;
  if (value === IDTYPE.NRIC || value === IDTYPE.NEW_BR_NO) {
    this.idValue2Length = 12;
  } else {
    this.idValue2Length = 20;
  }
}

checkIdValue2IsOnlyNumber() {
  let value = this.customerEditForm.controls['idType2'].value;
  if(value === IDTYPE.NRIC) {
    this.onlyNumber = true;
  }else {
    this.onlyNumber = false;
  }
}

showIdType2AndIdValue2() {
  return (!this.isCompany && this.isOldIC) || this.isCompany;
}

validateForm() {
  let valid = true;

  //validate company at least mobile no or fixed line no
  let mobileNo = this.customerEditForm.get('mobileNo').value;
  let fixedLineNo = this.customerEditForm.get('fixedLineNo').value;

  if(this.isCompany) {
    if(!mobileNo && !fixedLineNo) {
      this.atLeastMobileNoOrFixedLineNoStatus = false;
      valid = false;
      return valid;
    }else {
      this.atLeastMobileNoOrFixedLineNoStatus = true;
    }
  }

  if (this.validateUnitAddress1MaxLength()) {
    valid = false;
    return valid;
  } else {
    valid = true;
  }

  return valid;
}

correctMobileFixedFaxCode() {
  // Automatically update mobileCode, fixedLineCode, and faxCode to format 60XX when possible
  const mobileCodeList = this.lov.clientMobileCode1List;
  const fixedCodeList = this.lov.clientFax1CodeList;
  const faxCodeList = this.lov.clientFax1CodeList;

  if (this.cpDetails?.clientMobileCode1) {
    let existingMobileCode = mobileCodeList?.find(code => this.cpDetails.clientMobileCode1 == code.code);
    if (!existingMobileCode) {
      let tempMobileCode = '6' + this.cpDetails.clientMobileCode1;
      existingMobileCode = mobileCodeList?.find(code => tempMobileCode == code.code);
      if (!existingMobileCode) {
        this.customerEditForm.patchValue({
          mobileNoCode: ''
        });
      } else {
        this.customerEditForm.patchValue({
          mobileNoCode: existingMobileCode.code
        });
      }
    }
  }

  if (this.cpDetails?.clientPartnerAddress?.clientPhoneCode) {
    let existingFixedLineCode = fixedCodeList?.find(code => this.cpDetails.clientPartnerAddress.clientPhoneCode == code.code);
    if (!existingFixedLineCode) {
      let tempFixedLineCode = '6' + this.cpDetails.clientPartnerAddress.clientPhoneCode;
      existingFixedLineCode = fixedCodeList?.find(code => tempFixedLineCode == code.code);
      if (!existingFixedLineCode) {
        this.customerEditForm.patchValue({
          fixedLineNoCode: ''
        });
      } else {
        this.customerEditForm.patchValue({
          fixedLineNoCode: existingFixedLineCode.code
        });
      }
    }
  }

  if (this.cpDetails?.clientPartnerAddress?.clientFax1Code) {
    let existingFaxCode = faxCodeList?.find(code => this.cpDetails.clientPartnerAddress.clientFax1Code == code.code);
    if (!existingFaxCode) {
      let tempFaxCode = '6' + this.cpDetails.clientPartnerAddress.clientFax1Code;
      existingFaxCode = faxCodeList?.find(code => tempFaxCode == code.code);
      if (!existingFaxCode) {
        this.customerEditForm.patchValue({
          faxNoCode: ''
        });
      } else {
        this.customerEditForm.patchValue({
          faxNoCode: existingFaxCode.code
        });
      }
    }
  }
}

}
